import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

type SocialPost = {
	id: string;
	username: string;
	avatar: string;
	content: string;
	platform: "twitter" | "telegram";
	timestamp: string;
	likes: number;
};

const MOCK_POSTS: SocialPost[] = [
	{
		id: "1",
		username: "TrumpWarrior",
		avatar: "/trump-logo.png",
		content: "Just bought more $TRUMP! To the moon! 🚀",
		platform: "twitter",
		timestamp: "2m ago",
		likes: 42,
	},
	{
		id: "2",
		username: "CryptoMemer",
		avatar: "/trump-logo.png",
		content: "The games are so addictive! Love this community! 🎮",
		platform: "telegram",
		timestamp: "5m ago",
		likes: 28,
	},
	{
		id: "3",
		username: "HODLer4Life",
		avatar: "/trump-logo.png",
		content: "Check out my high score in Space Shooter! 🎯",
		platform: "twitter",
		timestamp: "15m ago",
		likes: 35,
	},
];

const SocialFeed = () => {
	const [posts, setPosts] = useState<SocialPost[]>(MOCK_POSTS);
	const [selectedPlatform, setSelectedPlatform] = useState<
		"all" | "twitter" | "telegram"
	>("all");

	return (
		<div className='space-y-4'>
			<div className='flex justify-between items-center mb-6'>
				<div className='flex items-center gap-2'>
					<h2 className='text-3xl font-black text-trump-yellow'>COMMUNITY</h2>
					<div className='relative group'>
						<span className='cursor-help text-white/60 hover:text-white'>ℹ️</span>
						<motion.div
							initial={{ opacity: 0, y: 10 }}
							animate={{ opacity: 1, y: 0 }}
							className='absolute left-0 top-full mt-2 w-64 p-4 bg-black/90 rounded-xl shadow-xl z-10 hidden group-hover:block'>
							<p className='text-white text-sm'>
								Live Twitter and Telegram integration coming soon! Stay tuned! 📱
							</p>
						</motion.div>
					</div>
				</div>
				<div className='flex gap-2'>
					{["all", "twitter", "telegram"].map((platform) => (
						<button
							key={platform}
							onClick={() => setSelectedPlatform(platform as any)}
							className={`px-4 py-2 rounded-full font-bold transition-colors ${
								selectedPlatform === platform
									? "bg-trump-yellow text-black"
									: "bg-white/10 text-white hover:bg-white/20"
							}`}>
							{platform === "all"
								? "All"
								: platform === "twitter"
								? "𝕏"
								: "Telegram"}
						</button>
					))}
				</div>
			</div>

			<div className='space-y-4 max-h-[400px] overflow-y-auto custom-scrollbar pr-2'>
				<AnimatePresence>
					{posts.map((post) => (
						<motion.div
							key={post.id}
							initial={{ opacity: 0, y: 20 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -20 }}
							className='bg-black/30 p-4 rounded-xl border-2 border-white/10 hover:border-white/30 transition-all duration-300'>
							<div className='flex gap-4'>
								<img
									src={post.avatar}
									alt={post.username}
									className='w-12 h-12 rounded-full'
								/>
								<div className='flex-1'>
									<div className='flex items-center gap-2'>
										<span className='font-bold text-white'>
											{post.username}
										</span>
										<span className='text-white/60 text-sm'>
											{post.timestamp}
										</span>
										{post.platform === "twitter" ? (
											<span className='text-blue-400'>𝕏</span>
										) : (
											<span className='text-blue-500'>Telegram</span>
										)}
									</div>
									<p className='text-white/80 mt-2'>{post.content}</p>
									<div className='flex items-center gap-4 mt-3'>
										<button className='text-white/60 hover:text-trump-yellow transition-colors flex items-center gap-1'>
											<span>❤️</span>
											<span>{post.likes}</span>
										</button>
										<button className='text-white/60 hover:text-trump-yellow transition-colors'>
											↩️ Share
										</button>
									</div>
								</div>
							</div>
						</motion.div>
					))}
				</AnimatePresence>
			</div>
		</div>
	);
};

export default SocialFeed;
